import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { focusField } from '../../../../common/utils/shared';
import { PATH_SEARCH_RESULTS } from '../../../../route/constants';
import { searchFormActions } from '../../../../store/searchForm';
import { FooterButtons } from '../../../components/FooterButtons';
import { useSearchFormSelector } from '../../../components/Form/utils/customHooks';

export const FooterForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const errorForm = (useSearchFormSelector('errorForm') as any).value;

  useEffect(() => {
    const { errorFields, bannerIsOpen } = errorForm;
    if (errorFields.length > 0 && bannerIsOpen) {
      dispatch(searchFormActions.setBannerIsOpen(true));
    }
  }, [errorForm.errorFields]);

  const handleSearchAction = () => {
    const { errorFields, bannerIsOpen } = errorForm;
    focusField();
    if (errorFields.length > 0 && !bannerIsOpen) {
      dispatch(searchFormActions.setBannerIsOpen(true));
    } else if (errorFields.length === 0) {
      dispatch(searchFormActions.setBannerIsOpen(false));
      navigate(PATH_SEARCH_RESULTS);
    }
  };

  return (
    <FooterButtons
      buttons={[
        {
          type: 'primary',
          text: 'Search',
          onClick: handleSearchAction,
          'data-testid': 'footer-button-search',
        },
      ]}
    />
  );
};
